import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { actionType } from 'utils/constants';
import selectors from 'state/selectors';
import actions from 'state/actions';
import CommonButton from 'components/Buttons/CommonButton';
import utils from 'utils';
import { modalActionType } from 'utils/constants';
import services from 'services';

const BlockUsers = () => {
  const t = utils.intl.useTranslator();
  const dispatch = useDispatch();
  const selectedUser = useSelector(selectors.configurator.getSelectedUser);

  const handleBlockSuccess = () => {
    if (!selectedUser) return;
    utils.app.notify('success', t('user_blocked_successfully'));
    dispatch(
      actions.configurator.updateTableRows({
        idUsers: [selectedUser.idUser],
        property: 'blocked',
        value: 1,
      }),
    );
    dispatch(actions.modal.closeModal());
    dispatch(actions.configurator.setSelectedUser(null));
  };

  const onConfirmForceBlockUser = async () => {
    if (!selectedUser) return;
    try {
      await services.blockUser({ idUser: selectedUser.idUser, forceBlock: true });
      handleBlockSuccess();
    } catch (error) {
      const err = error as any;

      if (err?.status === 409) {
        utils.app.notify('fail', err?.data?.reason ?? t('block_user_failed'));
      }
      dispatch(actions.modal.closeModal());
      dispatch(actions.configurator.setSelectedUser(null));
    }
  };

  const onConfirmBlockUser = async () => {
    dispatch(actions.configurator.setFormMode(null));
    if (!selectedUser) return;
    try {
      await services.blockUser({ idUser: selectedUser.idUser, forceBlock: false });
      handleBlockSuccess();
    } catch (error) {
      const err = error as any;
      if (err?.status === 409) {
        const { reason, forceBlockPrivilegeAvailable } = err?.data ?? {};
        dispatch(
          actions.modal.setModal({
            actionType: modalActionType.configurator.FORCE_BLOCK_USER,
            props: forceBlockPrivilegeAvailable
              ? {
                  subtitle: `${t('operation_failed_due_to')} ${reason}. ${t('do_you_still_want_to_block_the_user')}?`,
                  func: () => onConfirmForceBlockUser(),
                  dontCloseOnConfirm: true,
                }
              : {
                  subtitle: `${t('operation_failed_due_to')} ${reason}.`,
                  withConfirmButton: false,
                },
          }),
        );
        return;
      }
      dispatch(actions.modal.closeModal());
      dispatch(actions.configurator.setSelectedUser(null));
    }
  };

  return (
    <CommonButton
      id="block-user-btn"
      action={() =>
        dispatch(
          actions.modal.setModal({
            actionType: modalActionType.configurator.BLOCK_USER,
            props: {
              subtitle: `${t('are_you_sure_to_block')} ${selectedUser?.username ? selectedUser.name : t('this_user')}?`,
              func: () => onConfirmBlockUser(),
              dontCloseOnConfirm: true,
            },
          }),
        )
      }
      disabled={!(selectedUser && utils.user.isActionByCompanyActive(actionType.BLOCK_USER))}
      scope="tertiary"
      value={t('block-user')}
      customIcon="pause"
    />
  );
};

export default BlockUsers;
